module.exports = __webpack_public_path__ + "static/media/Properties_White.1aee9b0f.png";